/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
import { h700 } from '@atlaskit/theme/typography';
var fontFamily = getFontFamily();
var formHeaderContentStyles = css({
  minWidth: '100%',
  marginTop: "var(--ds-space-100, 8px)"
});
var formHeaderDescriptionStyles = css({
  marginTop: "var(--ds-space-100, 8px)"
});
var formHeaderTitleStyles = css({
  marginTop: 0,
  marginRight: "var(--ds-space-400, 32px)",
  lineHeight: "var(--ds-font-lineHeight-500, 32px)",
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  // Use "clip" overflow to allow ellipses on x-axis without clipping descenders
  '@supports not (overflow-x: clip)': {
    overflow: 'hidden'
  },
  '@supports (overflow-x: clip)': {
    overflowX: 'clip'
  }
});
var formHeaderWrapperStyles = css({
  fontFamily: "".concat(fontFamily)
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var darkH700Styles = css(h700({
  theme: {
    mode: 'dark'
  }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var lightH700Styles = css(h700({
  theme: {
    mode: 'light'
  }
}));
var FormHeaderContent = function FormHeaderContent(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: formHeaderContentStyles
  }, children);
};
var FormHeaderDescription = function FormHeaderDescription(_ref2) {
  var children = _ref2.children;
  return jsx("div", {
    css: formHeaderDescriptionStyles
  }, children);
};
var FormHeaderTitle = function FormHeaderTitle(_ref3) {
  var children = _ref3.children;
  var _useGlobalTheme = useGlobalTheme(),
    mode = _useGlobalTheme.mode;
  return jsx("h2", {
    css: [mode === 'light' ? lightH700Styles : darkH700Styles, formHeaderTitleStyles]
  }, children);
};
var FormHeaderWrapper = function FormHeaderWrapper(_ref4) {
  var children = _ref4.children;
  return jsx("div", {
    css: formHeaderWrapperStyles
  }, children);
};

/**
 * __Form header__
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */
var FormHeader = function FormHeader(_ref5) {
  var children = _ref5.children,
    description = _ref5.description,
    title = _ref5.title;
  return jsx(FormHeaderWrapper, null, title && jsx(FormHeaderTitle, null, title), description && jsx(FormHeaderDescription, null, description), children && jsx(FormHeaderContent, null, children));
};
export default FormHeader;
export { FormHeaderContent, FormHeaderDescription, FormHeaderTitle };